import React, { useContext, useEffect, useRef, useState } from "react";
import "./CustomWelcomeScreen.css";
import { isMobileDevice } from "web-store-modules/packages/obsess-device-detector";
import { AppContext } from "../../../../AppContext";
import { ThreeJSWorldContext } from "web-store-modules/packages/web-store-three-world";
import { ClickAnywhereToContinue, NavigationMenuOptionClicked } from "../../../../utils/Analytics";
import { isExhibit } from "../../../../utils/StoreConfigManager";

const southWall = "https://cdn.obsess-vr.com/umg/south-wall.png";
const northWall = "https://cdn.obsess-vr.com/umg/north-wall.png";
const westWall = "https://cdn.obsess-vr.com/umg/west-wall.png";
const eastWall = "https://cdn.obsess-vr.com/umg/east-wall.png";

const screenDuration = 10000;
const isMobile = isMobileDevice();
const CustomWelcomeScreen = (props) => {
  const { welcomeText } = props;
  const [screenNumber, setScreenNumber] = useState(1);
  const [welcomeText1, setWelcomeText1] = useState(welcomeText.split(":")[0]);
  const [welcomeText2, setWelcomeText2] = useState(welcomeText.split(":")[1]);
  const { setWelcomeScreenNumber } = useContext(AppContext);
  const { pushHistoryWithReset } = useContext(ThreeJSWorldContext);
  let delayFunc = null;
  const timeoutRef = useRef();

  useEffect(() => {
    return () => {
      setWelcomeScreenNumber(0);
      clearTimeout(delayFunc);
    };
  }, []);

  useEffect(() => {

    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      setScreenNumber((screenNumber) =>
        screenNumber < 5 ? screenNumber + 1 : screenNumber
      );
    }, screenDuration);

    setWelcomeScreenNumber(screenNumber);
    if (screenNumber === 5) {
      // redirect to entrance if user does not click to any screen
      delayFunc = setTimeout(() => {
        redirectToWall(null, "entrance");
      }, 10000);
      return () => {
        // clears timeout before running the new effect
        clearTimeout(delayFunc);
        clearTimeout(timeoutRef.current);
      };
    }
    
  }, [screenNumber]);

  const clickHandler = () => {
    if (screenNumber <= 4) {
      isExhibit && screenNumber > 1 && ClickAnywhereToContinue(screenNumber - 1);
      setScreenNumber(screenNumber + 1);
    } else {
      redirectToWall(null, "entrance");
    }
  };

  const redirectToWall = (e = null, scene) => {
    if (e) e.stopPropagation();

    pushHistoryWithReset(scene);
  };

  return (
    <>
      <div id='welcome-overlay'></div>
      <div
        onClick={clickHandler}
        className='outerWrapper'
        style={{ zIndex: `${screenNumber === 4 ? "13" : "12"}` }}
      ></div>
      <div
        className='fullScreen-welcome'
        style={{ display: `${screenNumber === 1 ? "" : "none"}` }}
      >
        <span className='welcome_text'>{welcomeText1}</span>
        <span className='welcome_text bold'>{welcomeText2}</span>
      </div>

      {/* First screen Arrow */}
     {!isMobile && <div
        className='arrowNavigation'
        style={{ display: `${[2, 4].includes(screenNumber) ? "" : "none"}` }}
      >
        <div className='arrowContainerLeft'>
          <div className='leftArrow'></div>
        </div>
        <div className='arrowContainerRight'>
          <div className='rightArrow'></div>
        </div>
      </div>}

      {/* Spotify Text */}
      <div
        className='spotify-modal-text-container'
        style={{ display: `${screenNumber === 4 ? "" : "none"}` }}
      >
        <p>Click on the spotify player to control the music</p>
      </div>

      {/* First screen Bottom Navigation*/}
      <div
        className='bottomNavigation'
        style={{ display: `${screenNumber === 2 ? "" : "none"}` }}
      >
        <div className='navigationText'>
          Use the navigation arrows to navigate the store
        </div>
        <div className='circleChevronBottom'></div>
      </div>

      {/* Second screen Arrow */}
      <div
        className={`arrowNavigation screen2`}
        style={{ display: `${screenNumber === 3 ? "" : "none"}` }}
      >
        <div className='arrowContainerLeft'>
          <div className='leftArrow'></div>
        </div>
        <div className='arrowContainerRight'>
          <div className='rightArrow'></div>
        </div>
        <p className='guidedText'>
          USE THE GUIDED ARROWS TO EXPLORE CURATED ART
        </p>
      </div>
      <div
        className='custom-welcome'
        onClick={clickHandler}
        style={{ display: `${screenNumber !== 1 ? "" : "none"}` }}
      >
        <div className='custom_welcome_text'>
          <span className='heading-main'>{welcomeText1}</span>
          <span className='heading-main heading-2'>{welcomeText2}</span>
        </div>
        {[2, 3, 4].includes(screenNumber) && (
          <div className='clickText'>Click anywhere to continue</div>
        )}
        {screenNumber === 5 && (
          <>
            <div className='start-explore'>
              Pick a place to start exploring{" "}
            </div>

            <div
              className='bottomWallScreens'
              style={{ display: `${screenNumber === 5 ? "" : "none"}` }}
            >
              <div
                className='wallimg'
                onClick={(e) => {
                  isExhibit && NavigationMenuOptionClicked("North Wall - initial")
                  redirectToWall(e, "north-wall")
                }}
              >
                <img src={northWall}></img>
                <p>North Wall</p>
              </div>
              <div
                className='wallimg'
                onClick={(e) => {
                  isExhibit && NavigationMenuOptionClicked("South Wall - initial")
                  redirectToWall(e, "south-wall")
                }}
              >
                <img src={southWall}></img>
                <p>South Wall</p>
              </div>
              <div
                className='wallimg'
                onClick={(e) => {
                  isExhibit && NavigationMenuOptionClicked("East Wall - initial")
                  redirectToWall(e, "east-wall")
                }}
              >
                <img src={eastWall}></img>
                <p>East Wall</p>
              </div>

              <div
                className='wallimg'
                onClick={(e) => {
                  isExhibit && NavigationMenuOptionClicked("West Wall - initial")
                  redirectToWall(e, "west-wall")
                }}
              >
                <img src={westWall}></img>
                <p>West Wall</p>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CustomWelcomeScreen;
